import './HomeBrand.styles.scss';
import Logo from '../Logo/Logo';

function HomeBrand() {
  return (
    <section className="brand">
      <Logo className="logo" />
    </section>
  );
}

export default HomeBrand;
